import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const n = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function a(i, c, s, f, p, d) {
  return o(), e("svg", r, c[0] || (c[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF9D5",
        d: "m36.03 32.655-7.801-8.513c.556-5.136 4.718-9.142 9.83-9.142 0 5.681 4.451 10.287 9.941 10.287 0 3.44-1.648 6.468-4.155 8.334l-7.816-.966Z"
      }),
      l("path", {
        fill: "#E5F2F9",
        d: "M38.947 31.657c-1.138 0-2.209.243-3.146.728-.702-4.791-4.718-8.472-9.538-8.472-5.256 0-9.54 4.375-9.674 9.79C13.443 34.12 11 36.896 11 40.334 10.998 44.015 13.876 47 17.424 47h21.521c4.082 0 7.396-3.436 7.396-7.673.002-4.234-3.311-7.67-7.394-7.67Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M38.06 13.75c.69 0 1.25.56 1.25 1.25 0 5 3.9 9.037 8.69 9.037.69 0 1.25.56 1.25 1.25a11.63 11.63 0 0 1-3.584 8.43 9.048 9.048 0 0 1 1.925 5.61c0 4.917-3.862 8.923-8.646 8.923H17.424c-4.25 0-7.677-3.555-7.674-7.916 0-3.579 2.272-6.629 5.467-7.607l.19-.056.02-.163c.681-5.45 5.13-9.696 10.55-9.84l.286-.005c.315 0 .628.014.937.042 1.142-5.16 5.582-8.955 10.86-8.955ZM26.262 25.163c-4.553 0-8.306 3.809-8.424 8.571a1.25 1.25 0 0 1-1.086 1.208c-2.558.34-4.503 2.617-4.503 5.393-.002 3 2.327 5.415 5.174 5.415h21.521c3.382 0 6.146-2.867 6.146-6.423a6.531 6.531 0 0 0-1.903-4.645 1.199 1.199 0 0 1-.346-.315l-.006-.01a5.964 5.964 0 0 0-3.889-1.45c-.951 0-1.824.2-2.57.588a1.25 1.25 0 0 1-1.812-.929c-.524-3.572-3.124-6.387-6.414-7.179a.301.301 0 0 1-.057-.002 1.252 1.252 0 0 1-.32-.078 7.983 7.983 0 0 0-1.511-.144Zm10.62-8.83-.098.015c-3.493.54-6.33 3.267-7.138 6.87 3.31 1.118 5.947 3.829 7.008 7.286l.057.195.12-.033a8.423 8.423 0 0 1 1.751-.252l.364-.007c1.826 0 3.517.583 4.91 1.578a9.093 9.093 0 0 0 2.81-5.454l.009-.075-.103-.012c-5.047-.662-9.034-4.786-9.674-9.977l-.016-.134Z"
      })
    ], -1)
  ]));
}
const h = /* @__PURE__ */ t(n, [["render", a]]);
export {
  h as default
};
